import React, { useState, useEffect } from "react";
import Card from "../../../Home/Components/Card";
import { ReactComponent as ReactPartnerGeneralIconCard } from "../../../Assets/NewIconsForCards/PartnerGeneralIcon.svg";
import { ReactComponent as ReactSoldToIconCard } from "../../../Assets/NewIconsForCards/SoldToIcon.svg";
import { ReactComponent as ReactShipToIconCard } from "../../../Assets/NewIconsForCards/ShipToIcon.svg";
import { ReactComponent as ReactCarrierIconCard } from "../../../Assets/NewIconsForCards/CarrierIcon.svg";
import { ReactComponent as ReactDriverIconCard } from "../../../Assets/NewIconsForCards/DriverIcon.svg";
import { ReactComponent as ReactAdminFunctionCard } from "../../../Assets/NewIconsForCards/UserSettingsIcon.svg";
import { ReactComponent as SearchIcon } from "../../../Assets/NewIconsForCards/SearchIcon.svg";
import { useUser } from "../../../hooks/useUser";
const CardsArray = [
  {
    title: "Partner Workbench",
    text: "",
    Icon: SearchIcon,
    link: "/PartnerWorkbench",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    title: "Partner General",
    text: "",
    Icon: ReactPartnerGeneralIconCard,
    link: "/PartnerGeneralOverview",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    title: "Sold To",
    text: "",
    Icon: ReactSoldToIconCard,
    link: "/PartnerSoldToOverview",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    title: "Ship To",
    text: "",
    Icon: ReactShipToIconCard,
    link: "/PartnerShipToOverview",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    title: "Carrier",
    text: "",
    Icon: ReactCarrierIconCard,
    link: "/PartnerCarrierOverview",
    roles: ["Admin", "SuperAdmin", "TerminalAdmin"],
  },
  {
    title: "Driver",
    text: "",
    Icon: ReactDriverIconCard,
    link: "/PartnerDriverOverview",
    roles: ["Admin", "SuperAdmin", "TerminalAdmin"],
  },
  {
    title: "Admin Function",
    text: "",
    Icon: ReactAdminFunctionCard,
    link: "/PartnerAdminFunctionOverview",
    roles: ["Admin", "SuperAdmin"],
  },
];

export default function PartnerOverview() {
  const [_user, ,] = useUser();
  const [newCards, setNewCards] = useState([]);

  useEffect(() => {
    if (!_user.roles) {
      return CardsArray;
    }
    let newCardArray = CardsArray.filter((card) => {
      //the find method returns the whole value based on true or false
      let foundRole = card?.roles?.find((role) => {
        //loop at each card roles, then check if role is in user role, return boolean from includes
        let foundinUserRoles = _user.roles.includes(role);
        //This is boolean is for find on line above
        return foundinUserRoles;
      });

      if (foundRole) {
        return card;
      }
    });

    setNewCards(newCardArray);
  }, []);

  return (
    <div className="mainContainer">
      <div className="overviewCardContainer">
        {newCards.map((record, i) => (
          <Card {...record} key={i} />
        ))}
      </div>
    </div>
  );
}
